import React, { useState, useEffect } from 'react';
import MultiListIndAsExceptionPopUp from '../atoms/MultiListIndAsExceptionPopUp';
function FromMoveIndAsExceptionList(props) {
  const [loading, setLoading] = useState(false);  // loader state here
  const handleClose = () => {
    props.setShowPopUpExIndAs(false);
    window.location.reload();  // Refresh page on close
  };
  return (
    <div className="row form-fields">
      <div className="label col-6" >
        <label>  </label>
      </div>
      <div className="item col-6" >
        <button onClick={() => { props.setShowPopUpExIndAs(true); }} className="btn btn-primary mb-2">
          &nbsp; Process &nbsp;<span className="bi bi-gear-fill"></span>
        </button>

        <MultiListIndAsExceptionPopUp
            titleExIndAs={props.labelExIndAs}
            showExIndAs={props.showPopUpExIndAs}
            showsetterExIndAs={handleClose}
            dataExIndAs={props.dataExIndAs}
            datasetterExIndAs={props.datasetterExIndAs}
            setLoadingAs={props.setLoadingAs}   // pass loader setter
            setProgress={props.setProgress}     // pass progress setter
            setTotal={props.setTotal}   // pass loader setter
        />
      </div>
    </div>
  )
}

export default FromMoveIndAsExceptionList